import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs'
import CommonCardHeader from '../../../CommonElements/CommonCardHeader/CommonCardHeader'
import ProductCheckout from '../ProductCheckout/ProductCheckout'
import RHVentes from './Ventes'
import RHMouvement from './Mouvements'


const VentesRapportHistorique = () => {
    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle={'Rapport et Historique'} parent={'Ventes'} />
            <Container fluid>
                <Row>
                    <Col xl="6" sm="12">
                        <RHVentes />
                    </Col>
                    <Col xl="6" sm="12">
                        <RHMouvement />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default VentesRapportHistorique